export function PageHeader() {
  return (
    <div className="max-w-4xl mx-auto text-center mb-8">
      <h1 className="text-3xl sm:text-4xl lg:text-7xl font-[300] mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-white">
        Create Automation Job
      </h1>
      <h4 className="text-sm sm:text-base lg:text-lg text-[#A2A2A2] leading-relaxed">
        Set up your automated blockchain tasks with precise conditions and
        parameters.
      </h4>
    </div>
  );
}
